import { type EmailTemplate, type EmailTemplatePurpose } from '../../../models/Scheduling'
import { useGetSchedulingEmailTemplatesQuery } from '../../../store/scheduling/scheduling'
import { useAppSelector } from '../../../store/hooks'
import { selectSafeAuthenticatedUser } from '../../../store/auth/authSlice'

export const useSchedulingEmailTemplates = () => {
  const accountId = useAppSelector(selectSafeAuthenticatedUser).accountId
  const { data: templates = [], isLoading } = useGetSchedulingEmailTemplatesQuery({ accountId })
  const findById = (id?: string): EmailTemplate | undefined => templates.find((template) => template.id === id)
  const forPurpose = (purpose: EmailTemplatePurpose): EmailTemplate[] => templates.filter((template) => template.purpose === purpose)
  return { templates, isLoading, findById, forPurpose }
}
